import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@1trading/react/components/ui/form';
import { RadioGroup, RadioGroupItem, RadioGroupItemCard } from '@1trading/react/components/ui/radio-group';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FUNDS_OWNERSHIPS } from '@/constants/institution';
import type { InstitutionBusinessProfileOrDefaults } from '@/features/institution/business-profile/schema';

const InstitutionBusinessProfileFieldsetFundsOwnership = () => {
  const form = useFormContext<InstitutionBusinessProfileOrDefaults>();
  const { t } = useTranslation();

  return (
    <FormField
      name="fundsOwnership"
      control={form.control}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('institutionDetails.businessProfile.fundsOwnership.title')}*</FormLabel>
          <FormControl>
            <RadioGroup defaultValue={field.value} variant="cards" aria-label={t('institutionDetails.businessProfile.fundsOwnership.title')} onValueChange={field.onChange}>
              {FUNDS_OWNERSHIPS.map((fundsOwnership) => (
                <FormItem key={fundsOwnership}>
                  <RadioGroupItemCard variant="outline">
                    <FormControl>
                      <RadioGroupItem value={fundsOwnership} />
                    </FormControl>
                    <FormLabel contained>{t(`institutionDetails.businessProfile.fundsOwnership.options.${fundsOwnership}`)}</FormLabel>
                  </RadioGroupItemCard>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
InstitutionBusinessProfileFieldsetFundsOwnership.displayName = 'InstitutionBusinessProfileFieldsetFundsOwnership';

export { InstitutionBusinessProfileFieldsetFundsOwnership };
